/**
 * Fixed vocabulary of roles a user can hold. Multiple roles per user are allowed.
 *
 * Two-part `domain.function` naming: domain names the concept (not the app),
 * function names what the holder can do. The dot is a disambiguation convention —
 * not a hierarchy, not a prefix to match on. No wildcards, no inheritance.
 * Code that prefix-matches role strings has built the RBAC system we decided not to build.
 *
 * Platform entitlement (free vs. paid) is `plan` on UserIdentity, not a role here.
 */
export type AppRole = "platform.admin" | "corpus.annotator" | "expert_insights.expert";

/** All defined roles, in a stable array for iteration (e.g. validation, admin UI dropdowns). */
export const APP_ROLES: readonly AppRole[] = [
  "platform.admin",
  "corpus.annotator",
  "expert_insights.expert",
] as const;

/**
 * Returns true when the role set satisfies the required role.
 * platform.admin is a wildcard — it satisfies any role check.
 */
export function hasRole(roles: AppRole[], required: AppRole): boolean {
  return roles.includes("platform.admin") || roles.includes(required);
}
